import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as purchaseActions from '../../../actions/purchaseActions';
import { routerActions } from 'connected-react-router';
import AppleStoreSvg from '../../../styles/assets/bitstop-app-apple-store.svg';
import GoogleStoreSvg from '../../../styles/assets/bitstop-app-google-store.svg';
import AppleStoreQR from '../../../styles/assets/bitstop-app-apple-store-qr.png';
import GoogleStoreQR from '../../../styles/assets/bitstop-google-app-store-qr.png';
import BitstopAppSvg from '../../../styles/assets/bitstop-app-layout-3.png';
import '../../../styles/FinishScreen/FinishScreen.css'
import Footer from '../../common/Footer';
import { FinishScreen as i18n } from '../../../middlewares/i18n';

class FinishScreen extends Component {

  constructor(props){
    super(props);
    this.state={
      address:'',
      timer: null
    }
  }

  componentDidMount(){
    let timer = setTimeout(()=>{
      this.props.actions.router.push('/');
    }, 90000);
    this.setState({
      timer
    })
  }

  componentWillUnmount(){
    clearTimeout(this.state.timer)
  }

  render(){
    const translations = i18n[this.props.i18n.language.current];
    const spanishClassIdentifier = this.props.i18n.language.current == 'es' ? 'spanish-lang' : '';
    return(
      <div className={`finish-screen__wrapper ${spanishClassIdentifier && spanishClassIdentifier}`}>
        <div className='starting-container bs-body centered'>
          <br />
          <div className='bs-logo-screen starting-logo'/>
          {!this.props.qa.qa_partial ? 
            <div>
              <h6 className='bs-subtitle no-margin' style={{fontSize: '50px'}}>{translations.greet1}</h6>
              <h6 className='bs-subtitle no-margin' style={{fontSize: '50px'}}>{translations.greet2}</h6>
            </div>
          : <div>
              <h6 className='bs-subtitle no-margin' style={{fontSize: '50px'}}>{translations.qa}</h6>
              <h6 className='bs-subtitle no-margin' style={{fontSize: '50px'}}>{translations.thankYou}</h6>
            </div>
          }
        </div>
        <div className='finish-screen__footer-container'>
          <div id="title-and-features" className="columns">
            <div id="title" className="column">
              <h2>{translations.welcomeHeader}</h2>
              <p>{translations.downloadMobileApp}</p>
            </div>
            <div className="column">
              <ul>
                {translations.appFeaturesList.map(feature => {
                  return (<li>{feature}</li>)
                })}
              </ul>
            </div>
          </div>
          <div id="download-qr-codes" className="columns">
            <div className="column">
              <img src={BitstopAppSvg} alt="Bitstop App Preview" />
            </div>
            <div className="columns">
              <div className="column apple">
                <img src={AppleStoreSvg} className="store-icon" alt="Apple App Store" />
                <img src={AppleStoreQR} className="qr-code" alt="Apple App Store QR Redirect" />
              </div>
              <div className="column google">
                <img src={GoogleStoreSvg} className="store-icon" alt="Google Play Store" />
                <img src={GoogleStoreQR} className="qr-code" alt="Google Play Store QR Redirect" />
              </div>
            </div>
          </div>
        </div>
        <Footer big={true} />
      </div>
    );
  }
}

function mapStateToProps(state){
  return{
    qa: state.qa,
    i18n: state.i18n
  }
}

function mapDispatchToProps(dispatch){
  return{
    actions: {
      router: bindActionCreators(routerActions, dispatch),
      purch: bindActionCreators(purchaseActions, dispatch)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishScreen);